module.exports = "/_next/static/images/6af14025feaa4c47d5960ea57a5c655a-people-smile-at-home-lg@2x.jpg.webp";